import { useTranslation } from 'react-i18next'
import { useNotifier } from '@cbgms/base/notifier'
import { SetupWizardStep, SetupWizardStepComponent } from 'app/menu/components/TopBarV1/setupWizard/SetupWizardStep'
import { useDispatch, useSelector } from 'react-redux'
import { generateSubmissionError } from 'utils/Form/SubmissionError'
import GradingIcon from '@mui/icons-material/Grading'
import shop from 'app/auth/state/reducers/shop'
import SetupWizardStepHaynesProEula from 'app/menu/components/TopBarV1/setupWizard/SetupWizardStepHaynesProEula'
import { IRootReducerState } from 'state/rootReducer'
import { updateShop } from 'app/shops/state/actions'

export const AcceptHaynesProEULACTA: SetupWizardStepComponent = props => {
  const { t } = useTranslation()
  const notifier = useNotifier()
  const dispatch = useDispatch()
  const shopId = useSelector((state: IRootReducerState) => state.auth.shop.ID)
  return (
    <SetupWizardStep
      {...props}
      step={{
        icon: <GradingIcon />,
        content: <SetupWizardStepHaynesProEula />,
        buttonText: t('SetupWizard.HaynesProAccept'),
        actionOnClick: async () => {
          try {
            await dispatch(updateShop(shopId, { ...shop, HasAcceptedHaynesproEULA: true }))
            props.refetch()
            notifier.success(t('SetupWizard.HaynesProEULASuccess'))
          } catch (error) {
            throw generateSubmissionError(error)
          }
        }
      }}
    />
  )
}
